import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { ICoefficientFilterInputValues } from "../../../../types/contractsInterface";

const initialState: any = {
  list: {},
  poses: [],
  count: 0,
  page: 1,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  filterInputValues: {} as ICoefficientFilterInputValues,
  requestStatusMessage: null,
};

export const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  reducers: {
    reducerGetCoefficientList: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      const temp: any = {};
      if (action.payload.data) {
        action.payload.data.map(
          (el: any) =>
            (temp[el.contract.id] = temp[el.contract.id]
              ? [...temp[el.contract.id], el]
              : [el])
        );
      }
      state.list = temp;
      state.count = action.payload.count ?? 0;
      if (action.payload.page !== undefined) {
        state.page = action.payload.page;
      }
      if (action.payload.limit !== undefined) {
        state.limit = action.payload.limit;
      }
    },
    reducerGetBudgetPoses: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.poses = action.payload;
    },
    reducerSetRequestStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.requestStatus = action.payload;
    },
    reducerSetRequestStatusMessage: (
      state: Draft<any>,
      action: PayloadAction<string | null>
    ) => {
      state.requestStatusMessage = action.payload;
    },
    reducerCoefficientFilterInputValues: (
      state: Draft<any>,
      action: PayloadAction<ICoefficientFilterInputValues>
    ) => {
      state.filterInputValues = action.payload;
    },
  },
});

export const {
  reducerGetCoefficientList,
  reducerGetBudgetPoses,
  reducerSetRequestStatus,
  reducerSetRequestStatusMessage,
  reducerCoefficientFilterInputValues,
} = contractsSlice.actions;

export default contractsSlice.reducer;
